__turbopack_context__.v({
  "container": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__container",
  "galImg": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__galImg",
  "galleryCat": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__galleryCat",
  "galleryItem": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__galleryItem",
  "galleryList": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__galleryList",
  "innerSlider": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__innerSlider",
  "navBtn": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__navBtn",
  "navWrapper": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__navWrapper",
  "root": "BeyondScreenCarouselComponentHomeNew-module-scss-module__IEtpha__root",
});
